'use strict';

var PercentFormatterDirective = function PercentFormatterDirective() {
  return {
    restrict: 'A',
    require: 'ngModel',
    controller: 'PercentFormatterController',
    link: function link($scope, elem, attr, ngModelCtrl) {
      ngModelCtrl.$parsers.push($scope.parser);
      ngModelCtrl.$formatters.push($scope.formatter);
    }
  };
};
PercentFormatterDirective.$inject = [];
module.exports = PercentFormatterDirective;